<template>
  <div class="col-md-12">
    <div class="card card-container">
      <h4 style="text-align: center;">Login</h4>
      <form name="form" @submit.prevent="handleLogin">
        <div class="form-group">
          <label for="username">ID Anda</label>
          <input
              id="username"
              v-model="user.username"
              v-validate="'required'"
              type="text"
              class="form-control"
              name="username"
          />
          <div
            v-if="errors.has('username')"
            class="alert alert-danger"
            role="alert"
          >ID Anda id tidak boleh kosong</div>
        </div>
        <div class="form-group">
          <label for="password">Kata Sandi</label>
          <input
            v-model="user.password"
            v-validate="'required'"
            type="password"
            class="form-control"
            name="password"
            id="password"
          />
          <div
            v-if="errors.has('password')"
            class="alert alert-danger"
            role="alert"
          >Kata sandi tidak boleh kosong</div>
        </div>
        <div class="form-group">
          <button class="btn btn-primary btn-block" :disabled="loading">
            <span v-show="loading" class="spinner-border spinner-border-sm"></span>
            <span>Masuk</span>
          </button>
        </div>
        <div class="form-group">
          <div v-if="message" class="alert alert-danger" role="alert">{{message}}</div>
        </div>
      </form>

      <div class="text-center mt-5">
        <span>version: {{ version }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import User from '../models/user';

export default {
  name: 'Login',
  data() {
    return {
      user: new User('', ''),
      loading: false,
      message: '',
      version: process.env.VUE_APP_VERSION
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  created() {
    if (this.loggedIn) {
      this.$router.push('/home');
    }
  },
  methods: {
    handleLogin() {
      this.loading = true;
      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.loading = false;
          return;
        }

        if (this.user.username && this.user.password) {
          this.$store.dispatch('auth/login', this.user).then(
            () => {
              this.$router.push('/home');
            },
            error => {
              this.loading = false;
              let errMsg =
                (error.response && error.response.data) ||
                error.message ||
                error.toString();
                
              try {
                /* eslint-disable no-console */
                if (process.env.NODE_ENV !== 'production') console.log( errMsg );
                /* eslint-enable no-console */

                if (errMsg.status !== undefined || errMsg.status !== "undefined") {
                  switch (errMsg.status) {
                    case 401:
                      errMsg = "ID / Kata sandi yang anda input salah";
                      break;
                    case 400:
                      errMsg = "Data yang anda input kurang. Harap periksa lagi";
                      break;
                    case 500:
                      errMsg = "Maaf, saat ini system sedang tidak dapat di akses. Cobalah beberapa saat lagi";
                      break;
                    case 502:
                    case 503:
                      errMsg =
                          "Maaf, saat ini salah satu service sedang mengalami gangguan. " +
                          "Cobalah beberapa saat lagi: [" + errMsg.error + "]"
                      ;
                      break;
                  }
                }
              } catch (e) {
                //show as is
                /* eslint-disable no-console */
                console.log( e );
                /* eslint-enable no-console */
              }
              this.message = errMsg;
            }
          );
        }
      });
    }
  }
};
</script>

<style scoped>
label {
  display: block;
  margin-top: 10px;
}

.card-container.card {
  max-width: 350px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 150px;
  height: 80px;
  margin: 0 auto 10px;
  display: block;
  /* -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%; */
}
</style>